<template>
    <ul class="firmContainer">
        <li class="firmItem" v-for="(firmItem, idx) in firmList" :key="idx">
            {{ firmItem }}
            <!-- <div class="topContext">
                <img class="image" :src="firmItem.img">
                <p class="text">{{ firmItem.text }}</p>
            </div>

            <div class="time">
                <img :src="timeIcon" />
                {{ firmItem.time }}
            </div> -->
        </li>
    </ul>
</template>

<script>
import timeIcon from "@/assets/img/jinju-2024/icon/icon_time@2x.png"
import msgCarouselImage1 from "@/assets/img/jinju-2024/msg_carousel_1.jpg"
import msgCarouselImage2 from "@/assets/img/jinju-2024/msg_carousel_2.jpg"
import msgCarouselImage3 from "@/assets/img/jinju-2024/msg_carousel_3.jpg"
import msgCarouselImage4 from "@/assets/img/jinju-2024/msg_carousel_4.jpg"

export default {
    data() {
        return {
            timeIcon,
            firmList: [
                { img: msgCarouselImage1, text: "专家学者共聚2024“影响力·时代”峰会，共话新金融新智造新动能", time: "5分钟前" },
                { img: msgCarouselImage2, text: "粤省情重磅发布《2024广东企业新质生产力发展调研报告》:广东上市公司新质生产力综合表现30强出炉", time: "5分钟前" },
                { img: msgCarouselImage3, text: "独家专访李君如：发展新质生产力关键在人才，教育机制仍需改革", time: "5分钟前" },
                { img: msgCarouselImage4, text: "专访粤开证券首席经济学家罗志恒：科技创新是新质生产力的基础，要重塑激励机制", time: "5分钟前" },
            ],
            firmList: [
                "企业名称企业名称",
                "企业名称企业名称",
                "企业名称", "企业名称企业名称",
                "企业名称企业名称", "企业名称企业名称",
                "企业名称企业名称", "企业名称企业名称",
                "企业名称企业名称", "企业名称企业名称",
                "企业名称企业名称", "企业名称企业名称",
                "企业名称企业名称", "企业名称",
                "企业名称企业名称", "企业名称企业名称",
                "企业名称企业名称", "企业名企业名称",
                "企业名称企业名称", "企业名称企业名称",
                "企业名称企业名称", "企业名称企业名称",
                "企企业名称", "企业名称企业名称",
                "企业名称企业名称", "企业名称企业名称",
                "企业", "企业名称企业名称",
                "企业名称企业名称", "企业名称企业名称",
                "企业名称企业名称", "企业名",
                "企业名称企业名称", "企业名称企业名称",
                "企业名称企业名称", "企业名称企业名称",
                "企业名称企业名称", "企业名称企业名称",
                "企业名称企业名称", "企业名称企业名称",
                "企业名称企业名称", "企业名称企业名称",
                "企业名称企业名称", "企业名称企业名称",
                "企业名称企业名称", "企业名称企业名称",
                "企业名称企业名称", "企业名称企业名称",
                "企业名称企业名称", "企业名称企业名称",
                "企业名称企业名称", "企业名称企业名称",
                "企业名称企业名称", "企业名称企业名称",
                "企业名称企业名称", "企业名称企业名称",
                "企业名称企业名称", "企业名称企业名称",
                "企业名称企业名称", "企业名称企业名称",
                "企业名称企业名称", "企业名称企业名称",
                "企业名称企业名称", "企业名称企业名称",
                "企业名称企业名称", "企业名称企业名称",
                "企业名称企业名称", "企业名称企业名称",
                "企业名称企业名称",
                "企业名称企业名称",

            ]
        }
    }
}
</script>

<style lang="scss" scoped>
.firmContainer {
    display: flex;
    margin-bottom: 20px;
    flex-wrap: wrap;
    margin-top: 61px;

    .firmItem {
        width: calc((100% - 50px) / 6);
        display: flex;
        flex-direction: column;
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 16px;
        color: #FFFFFF;
        margin-bottom: 22px;
    }
}
</style>
